// src/redux/store.js
import { configureStore } from '@reduxjs/toolkit';
import timeSheetDateRangeReducer from './slices/timeSheetDateRangeSlice';
import organisationDetailsReducer from './slices/organisationDetailsSlice';


const store = configureStore({
  reducer: {
    organisationDetails: organisationDetailsReducer,
    timeSheetDateRange: timeSheetDateRangeReducer
  },
  // Middleware and other settings can go here if needed
});

export default store;
